import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkUnitGridData = {
  consultant_name?: string;
  consultant_fullname?: string;
};

export const ConsultantCell = React.memo(({ consultant_fullname, consultant_name }: KpiWorkUnitGridData) => {
  const consultantName = consultant_fullname;

  if (consultantName) {
    return (
      <Tooltip title={consultantName}>
        <Typography variant="body2" noWrap>
          {consultantName}
        </Typography>
      </Tooltip>
    );
  }

  return (
    <Typography variant="body2" noWrap>
      {consultant_name ?? ''}
    </Typography>
  );
});

export default ConsultantCell;
